import type { ErrorComponentProps } from "@tanstack/react-router";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useTranslation } from "react-i18next";

function ErrorView(props: ErrorComponentProps) {
    const { reset } = props;
    const { t } = useTranslation("common");

    return (
        <Box
            role="alert"
            sx={[
                {
                    minHeight: {
                        xs: "calc(100vh - 56px)",
                        md: "calc(100vh - 64px)",
                    },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "background.default",
                    color: "text.primary",
                },
                theme =>
                    theme.applyStyles("dark", {
                        bgcolor: "background.paper",
                    }),
            ]}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    maxWidth: 480,
                    width: "100%",
                    px: 4,
                    py: 6,
                    borderRadius: 4,
                    boxShadow: 6,
                    bgcolor: "background.default",
                    textAlign: "center",
                }}
            >
                <ErrorOutlineIcon color="error" sx={{ fontSize: 72, mb: 2 }} />
                <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
                    {t("errorPage.title", "Oops! Something went wrong")}
                </Typography>
                <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
                    {t("errorPage.description", "An unexpected error occurred. Please try again or contact support if the problem persists.")}
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={reset}
                    sx={{ mt: 2, borderRadius: 2, fontWeight: 500, px: 4, py: 1.5 }}
                >
                    {t("errorBoundary.tryAgain")}
                </Button>
            </Box>
        </Box>
    );
}

export default ErrorView;
